// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"oF-z"};